const SearchError = props => {
    const p                         = props;
    return (
        <div className="modal-wrapper">
            <div className="modal">
                <div className="modal-header">
                    <div className="title">Hata</div>
                    <div className="close" onClick={ () => p.closeModal() }><div className="icon flat close"></div></div>
                </div>
                <div className="modal-content">
                    <div className="modal-content-wrapper">Aradığınız fatura bulunamadı. Lütfen bilgilerinizi kontrol edip tekrar deneyin.</div>
                </div>
                <div className="modal-footer">
                    <button className="button" onClick={ () => p.closeModal() }>Tamam</button>
                </div>
            </div>
        </div>
    )
}

export default SearchError